import PropTypes from 'prop-types';
import React from 'react';

import {
  WHITE,
  BLACK,
  PORCELAIN,
  PRIMARY_BLUE,
} from '@wetransfer/transfer/constant/colors';

const DownloadActive = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 121 170">
      <defs>
        <rect id="download-active-a" width="116" height="165" rx="4" />
        <filter
          x="-2.2%"
          y="-1.5%"
          width="106.9%"
          height="104.8%"
          filterUnits="objectBoundingBox"
          id="download-active-c"
        >
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="shadowSpreadOuter1"
          />
          <feOffset
            dx="3"
            dy="3"
            in="shadowSpreadOuter1"
            result="shadowOffsetOuter1"
          />
          <feComposite
            in="shadowOffsetOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowOffsetOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1146 0"
            in="shadowOffsetOuter1"
          />
        </filter>
      </defs>
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <mask id="download-active-b" fill={WHITE}>
          <use xlinkHref="#download-active-a" />
        </mask>
        <use
          fill={BLACK}
          filter="url(#download-active-c)"
          xlinkHref="#download-active-a"
        />
        <use fill={WHITE} xlinkHref="#download-active-a" />
        <rect
          strokeOpacity=".0751"
          stroke={BLACK}
          x="-.5"
          y="-.5"
          width="117"
          height="166"
          rx="4"
        />
        <g mask="url(#download-active-b)">
          <path
            d="M80.2132 25.7868c11.7157 11.7157 11.7157 30.7107 0 42.4264-11.7157 11.7157-30.7107 11.7157-42.4264 0-11.7157-11.7157-11.7157-30.7107 0-42.4264 11.7157-11.7157 30.7107-11.7157 42.4264 0zm-2.4957 2.4957c-10.3374-10.3375-27.0976-10.3375-37.435 0-10.3375 10.3374-10.3375 27.0976 0 37.435 10.3374 10.3375 27.0976 10.3375 37.435 0 10.3375-10.3374 10.3375-27.0976 0-37.435z"
            fill="#E6E8EB"
          />
          <g transform="translate(49.1176 36.4118)" fill="#E6E8EB">
            <rect x="8.8235" width="2.8235" height="17.6471" rx="1.4118" />
            <rect
              transform="rotate(45 14.0038 15.4156)"
              x="12.5921"
              y="8.3568"
              width="2.8235"
              height="14.1176"
              rx="1.4118"
            />
            <rect
              transform="rotate(-45 6.2392 15.4156)"
              x="4.8274"
              y="8.3568"
              width="2.8235"
              height="14.1176"
              rx="1.4118"
            />
          </g>
        </g>
        <path
          d="M.4957 132.5h115.008M-3 115.5h120"
          stroke={PORCELAIN}
          strokeLinecap="square"
          mask="url(#download-active-b)"
        />
        <rect
          fill={PORCELAIN}
          mask="url(#download-active-b)"
          x="8"
          y="122"
          width="50"
          height="4"
          rx="2"
        />
        <rect
          fill={PRIMARY_BLUE}
          mask="url(#download-active-b)"
          x="28"
          y="143"
          width="60"
          height="14"
          rx="7"
        />
        <path
          d="M32 89c0-1.1046.9026-2 2.0066-2h47.9868C83.1016 87 84 87.8877 84 89c0 1.1046-.9026 2-2.0066 2H34.0066C32.8984 91 32 90.1123 32 89z"
          fill={PORCELAIN}
          mask="url(#download-active-b)"
        />
        <rect
          fill={PORCELAIN}
          mask="url(#download-active-b)"
          x="40"
          y="94"
          width="36"
          height="3"
          rx="1.5"
        />
      </g>
    </svg>
  );
};

DownloadActive.propTypes = {
  className: PropTypes.string,
};

export default DownloadActive;
